'use client';
import { memo } from 'react';
import { IProps } from './interface';

export const RenderLastValue = memo<IProps>(function RenderLastValue({
  series,
  renderLastValue,
}) {
  if (!series || !series?.length || !renderLastValue) return null;

  // Find the first series with data (using safe access)
  let lastValue: number | undefined;

  for (const s of series) {
    if (
      s &&
      typeof s === 'object' &&
      'data' in s &&
      Array.isArray((s as any).data)
    ) {
      const data = (s as any).data;
      if (data.length > 0) {
        const lastPoint = data[data.length - 1];
        if (Array.isArray(lastPoint) && lastPoint.length > 1) {
          lastValue = lastPoint[1];
          break;
        }
      }
    }
  }

  if (lastValue === undefined || lastValue === null) return null;

  return (
    <div className="flex flex-col bg-gray-50 border-l-4 border-l-primary p-2 px-4 rounded-r">
      <span className="text-2xs leading-none">Atual</span>

      <span data-testid="current-value" className="text-sm font-semibold">
        {renderLastValue(lastValue)}
      </span>
    </div>
  );
});
